<div class="container-fluid">
    <h1 class="my-3 text-capitalize">{{pharos_credentials.id ? 'Actualizar':'Agregar'}} Credencial Pharos</h1>
    <form ngNativeValidate (submit)="save()">
        <div class="card p-3">
            <div class="row p-3">
                <div class="col-6 col-md-4">
                    <label class="">Nombre</label>
                    <input type="text" name="name" [(ngModel)]="pharos_credentials.name" class="form-control" required>
                </div>
                <div class="col-6 col-md-4">
                    <label class="">Usuario</label>
                    <input type="text" name="user" [(ngModel)]="pharos_credentials.user" class="form-control" required>
                </div>
                <div class="col-6 col-md-4">
                    <label class="">Contraseña</label>
                    <input type="text" name="password" [(ngModel)]="pharos_credentials.password" class="form-control" required>
                </div>
                <div class="col-6 col-md-4">
                    <label class="">Endpoint</label>
                    <input type="text" name="endpoint" [(ngModel)]="pharos_credentials.endpoint" class="form-control" >
                </div>
                <div class="col-6 col-md-4">
                    <label class="">Merchant Code</label>
                    <input type="text" name="merchant_code" [(ngModel)]="pharos_credentials.merchant_code" class="form-control">
                </div>
                <div class="col-6 col-md-4">
                    <label class="">Terminal Code</label>
                    <input type="text" name="terminal_code" [(ngModel)]="pharos_credentials.terminal_code" class="form-control" required>
                </div>
            </div>
            <div class="row p-3">
                <div class="col-12 text-right">
                    <button type="submit" [disabled]="is_loading" class="btn btn-primary">Guardar</button>
                </div>
            </div>
        </div>
    </form>
</div>
